//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {seoMixin} from '@/frontend/mixins/seoMixin'
import SimpleButtonGroup from '@/frontend/components/common/configurator/simple-button-group'
import ColoredStoneTypeToggle from '@/frontend/components/common/configurator/colored-stone-type-toggle'
import MetalButtonGroup from '@/frontend/components/common/configurator/metal-button-group'
import ColoredStoneButtonGroup from '@/frontend/components/common/configurator/colored-stone-button-group'
import RingSizeSelector from '@/frontend/components/common/configurator/ring-size-selector'
import Viewer from '@/frontend/components/common/configurator/viewer'
import {columnFormatterMixin} from '@/mixins/columnFormatterMixin'
import html2canvas from 'html2canvas'
import {mapMutations, mapState} from 'vuex'
import {getShoppingCartSID} from '@/utils/helpers'
import ProductCard from '@/frontend/components/common/product-card'
import FontStyle from '@/frontend/components/common/configurator/font-style'
import PhotoJewelry from '@/frontend/components/common/configurator/photo-jewelry'
import PhotoJewelryEngravings from '@/frontend/components/common/configurator/photo-jewelry-engravings'
import Engravings from "@/frontend/components/common/configurator/engravings";
import NameplateEngravings from "@/frontend/components/common/configurator/nameplate-engravings";
import _ from 'lodash';
export default {
  name: 'ProductDetail',
  components: {
    Viewer,
    MetalButtonGroup,
    ColoredStoneTypeToggle,
    SimpleButtonGroup,
    ColoredStoneButtonGroup,
    RingSizeSelector,
    ProductCard,
    FontStyle,
    PhotoJewelry,
    PhotoJewelryEngravings,
    NameplateEngravings,
    Engravings,
  },
  mixins: [seoMixin, columnFormatterMixin],
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      priceRequestCancel: null,
      product: null,
      productSummary: [],
      stonePositions: null,
      addToCartEnabled: 1,
      isUpdate: false,
      /* tmp data */

      breadcrumbs: [],
      smallImages: [
        {
          src: '/UnavailableLarge.png',
          selected: true,
        },
        {
          src: '/UnavailableLarge.png',
          selected: false,
        },
      ],
      scrollY: 0,
      addToCartInProgress: false,
      randomProducts: [],
      productCategory:'',
      calculatingPrice: false,
      currentCalculationId: 0,
    }
  },
  head() {
    const info = {
      title: this.product ? this.product.Title : '',
      description: '',
      url: '',
    }
    return this.getHead(info)
  },
  async created() {
    this.calculatingPrice = true;
    const sku = this.$route.params.pathMatch.split('/').pop()
    await this.$store.dispatch('common/formatter/fetchFormatSettings')
    this.product = await this.$axios.$get(`/configurator/getproduct/${sku}`)

    this.loadBackProductAfterLogin()

    this.updateBreadcrumbs()
    if (!this.product.ErrorMessage) {
      this.product.ColoredStoneType =
          (this.product.FormData.CST && this.product.FormData.CST.Value) ||
          'GEN'
      if (this.$route.query && this.$route.query.cartItem) {
        this.isUpdate = true
        const editedCartItemId = this.$route.query.cartItem

        if (!this.cartItems) {
          await this.$store.dispatch('shoppingCart/frontendGetBySessionId')
        }

        const cartItems = []
        Object.assign(cartItems, this.cartItems)
        const editedCartItem = cartItems.find(
          (cartItem) => cartItem.id.toString() === editedCartItemId.toString()
        )

        if (editedCartItem) {
          this.product.Quantity = editedCartItem.quantity

          const jsonFormData = await this.$axios.$get(
            'Configurator/getFormData/' + editedCartItem.id
          )
          const formData = jsonFormData

          if (formData) {
            this.product.FormData = formData
            this.product.ColoredStoneType =
                (this.product.FormData.CST && this.product.FormData.CST.Value) ||
                'GEN'
            this.product.StoneNr = this.product.FormData.STNB.Value
          }
        }
      }
      this.stonePositions = await this.$axios.$get(
        `${this.apiRootUrl}products/${this.product.Code}/${this.product.Code}.js?v=${this.$config.contentVersion}`,
        {}
      )
      this.product.ImageURL = `${this.apiRootUrl}products/${
        this.product.Code
      }/${this.product.Code}_${this.getCurrentMetalColor()}_${
        this.product.StoneNr
      }.png`

      this.recalculateProductPrice();
    } else {
      this.$toast.error(
        `There was an error loading product information! ${this.product.ErrorMessage}`
      )
    }
    this.randomProducts = []
    this.getProducts()
    this.updateProductSummary()
  },
  computed: {
    ...mapState('shoppingCart', ['cartItems']),
    ...mapState('frontend/productDetail',['productDetail']),
    apiRootUrl() {
      return this.$config.axios.browserBaseURL.replace('api/', '')
    },
    canBeAddedToCart() {
      let hasValues = true
      for (const item in this.product.FormData) {
        if (item == 'CS') {
          let counter = 1
          for (const subItem in this.product.FormData[item]) {

            if (counter <= this.product.StoneNr  && this.product.FormData["ENGRAVABLE"].Value  == 1 && this.$refs.coloredStoneButtonGroup_CS){

              let position =  subItem.split('_')[0];

              if (this.$refs.coloredStoneButtonGroup_CS[0].stoneHasEngraving(this.product.StoneNr, position)){

                if (this.$refs.coloredStoneButtonGroup_CS[0].stoneHasTwoEngraving(this.product.StoneNr, position) && this.product.StoneNr == 1){

                  if (!this.product.FormData[item][subItem].SecondValue ||  !this.product.FormData[item][subItem].ThirdValue)
                    hasValues = false

                }else{

                  if (!this.product.FormData[item][subItem].SecondValue)
                     hasValues = false

                }
              }
            }

            if (
              !this.product.FormData[item][subItem].Value &&
              counter <= this.product.FormData.STNB.Value
            ) {
              hasValues = false
            }
            counter++
          }
        } else if (
          item == 'SIZE' &&
          this.product.FormData[item] &&
          this.product.FormData[item].Value == '0'
        ) {
          hasValues = false
        }
      }
      return hasValues && this.addToCartEnabled === 1
    },
    availableStonesTypes() {
      const coloredStonesControl = this.product.Controls.find(
        (x) => x.name === 'CS'
      )
      const genuine = []
      const synthetic = []
      if (coloredStonesControl) {
        try {
          coloredStonesControl.GroupedOptions.map((stoneNumber) => {
            stoneNumber.GroupedOptions.map((stoneType) => {
              switch (stoneType.Key) {
                case 'GEN':
                  stoneType.Options.map((option) => {
                    genuine.push(
                      option.value.includes('DI.')
                        ? option.text
                        : option.text2.split('<')[0]
                    )
                  })
                  break
                case 'SYN':
                  stoneType.Options.map((option) => {
                    synthetic.push(
                      option.value.includes('DI.')
                        ? option.text
                        : option.text2.split('<')[0]
                    )
                  })
                  break
              }
            })
          })
        } catch (e) {
          console.log('Error while getting available stones: ', e)
        }
        return (
          `<br\><br\>` +
          `<b>Genuine Birthstone Availability: </b>` +
          `${genuine
            .filter((value, index, self) => self.indexOf(value) === index)
            .join(', ')}` +
          `<br\><br\>` +
          `<b>Synthetic Birthstone Availability: </b>` +
          `${synthetic
            .filter((value, index, self) => self.indexOf(value) === index)
            .join(', ')}`
        )
      }
    },
    IsEngravingEmpty(){
      if (this.product.FormData["ENGRAVABLE"].Value == "1"){

        if (this.product.FormData.PHOTO_JEWELRY_ENGRAVINGS){
          return this.product.FormData.PHOTO_JEWELRY_ENGRAVINGS.ValueArray.length <= 0 || this.product.FormData.PHOTO_JEWELRY_ENGRAVINGS.ValueArray.some(x => x == '')
        }

        if (this.product.FormData.NAMEPLATE_ENGRAVINGS){
          return this.product.FormData.NAMEPLATE_ENGRAVINGS.ValueArray.length <= 0 || this.product.FormData.NAMEPLATE_ENGRAVINGS.ValueArray.some(x => x == '')
        }
        //Styles with engraving and no stone
        if (this.product.FormData.ENGRAVINGS && this.product.StoneNr <= 0){
          return this.product.FormData.ENGRAVINGS.ValueArray.length <= 0 || this.product.FormData.ENGRAVINGS.ValueArray.some(x => x == '')
        }



        return false;
      }
      return false;
    }
  },
  methods: {
    ...mapMutations('frontend/productDetail', ['setProduct', 'deleteProduct']),
    updateProductSummary() {
      const summaryArray = [
        {
          label: 'Style Number',
          value: this.product.Code,
          bold: true,
          visible: true,
        },
      ]
      if (
        this.product.FormData.STNB &&
        this.product.FormData.STNB.Value &&
        this.product.FormData.STNB.Value != '0'
      ) {
        summaryArray.push({
          label: 'Number of Stones',
          value: this.product.FormData.STNB.Value,
          bold: true,
          visible: !!this.product.FormData.STNB.Value,
        })
      }

      let metalIndex = 1
      const numberOfDifferentMetals = Object.keys(this.product.FormData.MA)
        .length
      for (const metalKey in this.product.FormData.MA) {
        console.log(
          'product summary value ',
          this.product.FormData.MA[metalKey].Summary
        )
        summaryArray.push({
          label:
            numberOfDifferentMetals && numberOfDifferentMetals > 1
              ? `Metal Type ${metalIndex}`
              : 'Metal Type',
          value: this.product.FormData.MA[metalKey].Summary,
          bold: true,
          visible: !!this.product.FormData.MA[metalKey].Value,
        })
        metalIndex++
      }

      const value = this.getControlOptionNameByValue(
        'CST',
        this.product.FormData.CST ? this.product.FormData.CST.Value : ''
      )
      if (this.product.FormData.CST) {
        summaryArray.push({
          label: 'Stone Type',
          value,
          bold: true,
          visible: !!value,
        })
      }

      const stoneNumber = this.product.FormData.STNB.Value
      const engravings = []
      for (let i = 1; i <= stoneNumber; i++) {
        for (const key in this.product.FormData.CS) {
          if (key.startsWith(`${i.toString()}_`)) {
            const coloredStone = this.product.FormData.CS[key]
            summaryArray.push({
              label: `Stone ${i}`,
              value: coloredStone.Value
                ? `${coloredStone.Summary}`
                : 'Not yet selected',
              bold: false,
              visible: true,
            })
            engravings.push({
              label: `Engraving ${i}`,
              value: coloredStone.SecondValue,
              bold: false,
              visible: !!coloredStone.SecondValue,
            })
            
            if (coloredStone.ThirdValue && coloredStone.ThirdValue !== ''){
              engravings.push({
                label: `Engraving ${++i}`,
                value: coloredStone.ThirdValue,
                bold: false,
                visible: !!coloredStone.ThirdValue,
              })
            }
          }
        }
      }

      if (
        this.product.FormData.ENGRAVABLE &&
        this.product.FormData.ENGRAVABLE.Value &&
        engravings.some((x) => x.visible)
      ) {
        summaryArray.push({
          label: `Engravings`,
          value: '',
          bold: true,
          visible: true,
        })
        summaryArray.push(...engravings)
      }

      if (this.product.FormData.SIZE) {
        summaryArray.push({
          label: 'Ring Size',
          value: this.product.FormData.SIZE.Value.split('_')[1],
          bold: true,
          visible: !!this.product.FormData.SIZE.Value,
        })
      }

      const widthAttribute = this.product.Product.CustomAttributes.find(
        (attribute) => attribute.Code === 'WIDTH'
      )
      if (widthAttribute) {
        summaryArray.push({
          label: widthAttribute.DisplayName,
          value: widthAttribute.Value,
          bold: true,
          visible: !!widthAttribute.Value,
        })
      }

      const heightAttribute = this.product.Product.CustomAttributes.find(
        (attribute) => attribute.Code === 'HEIGHT'
      )
      if (heightAttribute) {
        summaryArray.push({
          label: heightAttribute.DisplayName,
          value: heightAttribute.Value,
          bold: true,
          visible: !!heightAttribute.Value,
        })
      }
      const descriptionAttribute = this.product.Product.CustomAttributes.find(
        (attribute) => attribute.Code === 'DESCRIPTION'
      )
      if (descriptionAttribute) {
        summaryArray.push({
          label: descriptionAttribute.DisplayName,
          value: descriptionAttribute.Value,
          bold: true,
          visible: !!descriptionAttribute.Value,
        })
      }
      this.productSummary = summaryArray
    },
    getControlOptionNameByValue(controlName, optionValue) {
      const control = this.product.Controls.find(
        (control) => control.name === controlName
      )
      if (!control) return 'Not yet selected'
      return control.Options.find((option) => option.value === optionValue).text
    },
    /* ...mapActions('frontend/configurator/product-detail', [
      'fetchProductBySKU',
    ]), */
    smallImageClick(image) {
      this.smallImages.map((si) => {
        si.selected = si.src === image.src
      })
    },
    getMetalNameCSS(metalColor) {
      const color = metalColor.includes(' ')
        ? metalColor.split(' ')[0]
        : metalColor
      return `${color}-metal-name-background-color`
    },
    async toCanvas() {
      const canvas = await this.$html2canvas(this.$refs.imageComposer)
    },

    getControlFromControls(control) {
      return this.product.Controls.find(
        (x) => x.type === control.type && x.name === control.name
      )
    },
    getCurrentMetalColor() {
      let metalColors = ''
      for (const item in this.product.FormData.MA) {
        if (!this.product.FormData.MA[item].Value) {
          continue
        }
        const currentMetalColor =
          this.product.FormData.MA[item].Value == 'SLV'
            ? this.product.FormData.MA[item].Value
            : this.product.FormData.MA[item].Value.slice(-1) + 'G'
        metalColors =
          metalColors == ''
            ? currentMetalColor
            : metalColors + '_' + currentMetalColor
      }
      return metalColors
    },
    delay(time) {
      return new Promise((resolve) => setTimeout(resolve, time))
    },
    reloadProductImage() {
      this.product.ImageURL =
        this.apiRootUrl +
        'products/' +
        this.product.Code +
        '/' +
        this.product.Code +
        '_' +
        this.getCurrentMetalColor() +
        '_' +
        this.product.StoneNr +
        '.png?v=' +
        this.$config.contentVersion
      this.$nextTick(() => {
        if (this.$refs.ImageViewer) {
          this.$refs.ImageViewer.updateImage(
            this.$refs.ImageViewer.updateBacksideImage
          )
        }
      })
    },
    updateValue(
      {
        controlType,
        controlName,
        controlSubName,
        value,
        secondValue,
        thirdValue,
        summary,
      },
      reRenderAndCalculate = true
    ) {
      const control = this.product.FormData[controlName]
      switch (controlType) {
        case 'metalButtonGroup':
          console.log('after update value', summary)
          this.product.FormData.MA[controlName].Value = value
          this.product.FormData.MA[controlName].SecondValue = secondValue
          this.product.FormData.MA[controlName].Summary = summary
          break
        case 'simpleButtonGroup':
          control.Value = value
          this.product.StoneNr = value
          break
        case 'coloredStoneTypeToggle':
          control.Value = value
          this.product.ColoredStoneType = value
          break
        case 'selectInput':
          control.Value = value
          break
        case 'photoJewelry':
          control.Value = value
          this.product.PhotoJewelry = value
          break
        case 'fontStyle':
          control.Value = value
          control.SecondValue = secondValue
          this.product.FontStyle = value
          break
        case 'ringSizeSelector':
          control.Value = value
          break
        case 'coloredStoneButtonGroup':
          if (controlSubName) {
            if (value !== undefined) {
              control[controlSubName].Value = value
            }
            if (secondValue !== undefined) {
              control[controlSubName].SecondValue = secondValue
            }
            if (thirdValue !== undefined) {
              control[controlSubName].ThirdValue = thirdValue
            }
            if (summary !== undefined) {
              control[controlSubName].Summary = summary
            }
          } else {
            control.Value = value
            control.Summary = summary
          }
          if (this.product.Product.SubItems.some(x => x.ItemGroupCode === "DIA")) {
            this.changeDescriptionBasedOnDiamond(value)
          }
          break
        case 'price':
          control.Value = value
          break
        case 'cost':
          if (value) {
            control.Value = value
          }
          if (secondValue) {
            control.SecondValue = secondValue
          }
          break
        case 'photoJewelryEngravings':
          if (!control.ValueArray || control.ValueArray === '') {
            control.ValueArray = []
          }
          if (control.ValueArray[controlSubName] || control.ValueArray[controlSubName] === "") {
            control.ValueArray.splice(controlSubName, 1);
          }
          control.ValueArray.splice(controlSubName, 0, value)
          break
        case 'engravings':
        case 'nameplateEngravings':
          if (!control.ValueArray || control.ValueArray === '') {
            control.ValueArray = []
          }
          if (control.ValueArray[controlSubName] || control.ValueArray[controlSubName] === "") {
            control.ValueArray.splice(controlSubName, 1);
          }
          control.ValueArray.splice(controlSubName, 0, value)
          break
      }
      if (reRenderAndCalculate) {
        if (controlType === 'photoJewelryEngravings' || controlType === 'fontStyle') {
          this.$refs.ImageViewer.updateBacksideImage(false)
        } else {
          this.reloadProductImage()
        }
        this.recalculateProductPrice()
        this.updateProductSummary()
      }
    },
    async recalculateProductPrice() {
      // Generate a unique identifier for this calculation process
      const currentCalculationId = Math.random().toString(36).substring(7);

      this.calculatingPrice = true;
      this.currentCalculationId = currentCalculationId;

      if (this.priceRequestCancel) {
        this.priceRequestCancel.cancel()
      }
      this.priceRequestCancel = this.$axios.CancelToken.source()

      this.setAddToCartEnabled(false)
      try {
        const result = await this.$axios.$post(
          '/configurator/calculateproductprice',
          this.product,
          {
            cancelToken: this.priceRequestCancel.token,
          }
        )
        this.product.Price = result.value.price.value
        this.updateValue(
          {
            controlType: 'price',
            controlName: 'PRICE',
            value: this.product.Price,
          },
          false
        )
        this.updateValue(
          {
            controlType: 'cost',
            controlName: 'COST',
            value: result.value.cost.value,
          },
          false
        )
        this.updateValue(
          {
            controlType: 'cost',
            controlName: 'COST',
            secondValue: result.value.cost.secondValue,
          },
          false
        )
      } catch (error) {
        console.error(error)
      }

      // Check if the current calculation matches the latest user action
      if (this.currentCalculationId === currentCalculationId) {
        // If it matches, set the loader to false and re-enable user interaction
        this.calculatingPrice = false;
      }
      this.setAddToCartEnabled(true)
    },
    setAddToCartEnabled(value) {
      this.addToCartEnabled += value ? 1 : -1
    },
    getTextStyleForHtml2Canvas(canvas) {
      if (canvas.querySelector('#EngravingSVG')) {
        if (navigator.userAgent.search('MSIE') > 0) {
          canvas.querySelector('#EngravingSVG').style =
            'font-size: 1rem;text-shadow: 0.5px 0.5px 0.5px rgba(255,255,255,.8), -0.5px -0.5px 0.5px rgba(255,255,255,.8);fill:#080707e6;'
        } else if (navigator.userAgent.search('Chrome') > 0) {
          canvas.querySelector('#EngravingSVG').style =
            'font-size: 1rem;text-shadow: 0.5px 0.5px 0.5px rgba(255,255,255,.8), -0.5px -0.5px 0.5px rgba(255,255,255,.8);fill:#080707e6;'
        } else if (navigator.userAgent.search('Firefox') > 0) {
          canvas.querySelector('#EngravingSVG').style =
            'font-size: 1rem;text-shadow: rgba(255, 255, 255, 0.7) 2px 2px 2px, rgba(255, 255, 255, 0.7) -2px -2px 2px;;fill:#080707e6;'
        } else {
          canvas.querySelector('#EngravingSVG').style =
            'font-size: 1rem;text-shadow: rgba(255, 255, 255, 0.7) 2px 2px 2px, rgba(255, 255, 255, 0.7) -2px -2px 2px;;fill:#080707e6;'
        }
      }
      return canvas
    },
    async addToCart() {
      this.setAddToCartEnabled(false)
      if (!this.$auth.loggedIn) {
        this.$toast.info(this.$t('login_to_access_cart'))
        this.setProduct({product: this.product})
        this.$router.push({path: '/user-login'})
        this.setAddToCartEnabled(true)

        return
      }

      if (this.IsEngravingEmpty) {
        this.$toast.error(this.$t('fill_engraving'))
        this.setAddToCartEnabled(true)
        return;
      }

      try {
        this.addToCartInProgress = true
        const vm = this

        const canvas = await html2canvas(
          this.$refs.ImageViewer.$refs.ProductImage,
          {
            scale: 1,
            width: 445,
            height: 445,
            onclone(canvas) {
              canvas.querySelector('#ProductImage').style = 'display: block; width: 455px';
              vm.getTextStyleForHtml2Canvas(canvas)
            },
          }
        )
        this.product.ImageData = canvas.toDataURL('image/png')

        // there is an engraving on the backside of the jewelry
        if (this.stonePositions.PhotoJewelry && this.stonePositions.PhotoJewelry.hasTwoSides) {
          const canvas = await html2canvas(
            this.$refs.ImageViewer.$refs.ProductBackImage,
            {
              scale: 1,
              width: 445,
              height: 445,
              onclone(canvas) {
                canvas.querySelector('#ProductBackImage').style = 'display: block; width: 455px';
                vm.getTextStyleForHtml2Canvas(canvas)
              },
            }
          )
          // Palomar CP: backside image of product
          this.product.Image2Data = canvas.toDataURL('image/png')
        }

        this.product.sessionId = getShoppingCartSID()

        if (this.isUpdate) {
          this.product.cartItemID = this.$route.query.cartItem
        }
        this.product.itemTypeData = {usePriceFromJobItem: true}

        const response = await this.$axios.$post(
          '/configurator/addtocart',
          this.product
        )
        this.addToCartInProgress = false
        if (response.apiMessages.hasErrors === true) {
          if (response.apiMessages.serverErrors) {
            this.$toast.error(
              `There was an issue ${
                this.isUpdate
                  ? 'updating the cart item!'
                  : 'adding your product to the cart'
              }!`
            )
          }
        } else {
          this.$store.dispatch('shoppingCart/frontendGetBySessionId')
          this.$router.push('/shopping-cart')
        }
      } catch (error) {
        this.addToCartInProgress = false
      }
      this.setAddToCartEnabled(true)
    },
    async getbreadcrumbs(collectionName) {
      if (collectionName) {
        await this.$axios.get(
          '/ProductCategories/categoryCode/' +
          collectionName
        ).then((category) => {
          if (!category.data.hasErrors) {
            this.productCategory = category.data.value
          }
        })
      } else {
        await this.$axios.get(
          '/ProductCategories/categorybysku/' +
          this.product.Code
        ).then((category) => {
          if (!category.data.hasErrors) {
            this.productCategory = category.data.value
          }
        })
      }

      return {
        text: this.productCategory.title,
        disabled: false,
        href: `/collections/${this.productCategory.code}`,
      }

    },
    async updateBreadcrumbs() {
      this.breadcrumbs.push({
        text: "Home",
        disabled: false,
        href: `/home`,
      })

      let collectionCode = this.$route.query.from
      let breadcrumb = await this.getbreadcrumbs(collectionCode)
      if (breadcrumb) {
        this.breadcrumbs.push(breadcrumb)
      }
      this.breadcrumbs.push({
        text: this.product.Title,
        disabled: true,
        href: ``,
      })
    },
    getProducts() {
      const lowerCaseDescription =
        this.product.Title && this.product.Title.toLowerCase().split('(')[0]
      if (lowerCaseDescription) {
        const generalCategory = this.getRelatedGeneralCategories(lowerCaseDescription)
        if (generalCategory) {
          this.$axios
            .$get(
              '/ProductCategories/RetailProducts/' +
              generalCategory +
              `?PageSize=${4}&PageNo=${1}`
            )
            .then((products) => {
              this.randomProducts = products
            })
        }
      }
    },
    getRelatedGeneralCategories(lowerCaseDescription) {
      switch (true) {
        case lowerCaseDescription.includes(' ring'):
          return 'rings'
        case lowerCaseDescription.includes(' necklace'):
        case lowerCaseDescription.includes(' pendant'):
          return 'necklaces'
        case lowerCaseDescription.includes(' bracelet'):
          return 'bracelets'
        default:
          return null
      }
    },
    changeDescriptionBasedOnDiamond(value) {
      let variants = this.product.Product.Variants.find(x => x.ItemGroupCode === "DIA");

      if (variants.Variants.length <= 2) {
        return;
      }

      if (!value.includes('&')) {
        return
      }

      let variantCustomAttr = variants.Variants.find(x => x.VariantID == value.split('&')[1]);
      let diaDesc = variantCustomAttr.CustomAttributes.find(x => x.Code === "DIA_DESC");

      if (diaDesc) {
        this.product.Desc = diaDesc.ValueStr;
        this.product.Desc2 = diaDesc.ValueStr;
        this.product.Title = diaDesc.ValueStr;
      }
    },
    loadBackProductAfterLogin() {
      if (this.productDetail && this.productDetail.Code === this.product.Code
        && (
          this.$nuxt.context.from &&
          this.$nuxt.context.from.fullPath.includes('user-login'))
      ) {
        this.$toast.info(this.$t('add_to_cart_after_login'))
        this.product = this.productDetail
      }
      this.deleteProduct()
    },
  }
}

